import { objectKeyProbe } from '@/utils';
import isEmpty from 'lodash/isEmpty';

/**
 * @name keymapResponseHandle
 * @description 处理 keymap 数据
 * @param response
 * @returns options
 */
export function keymapResponseHandle(response: any) {
  if (!response) return [];
  const [hasItems, items] = objectKeyProbe(response, 'items');
  const keymaps = hasItems ? items : [];
  const options = keymaps
    .filter((item) => {
      return !isEmpty(item.data);
    })
    .map((item) => {
      const extraOptions = Object.keys(item.data).map((key) => ({
        label: key,
        value: key,
      }));
      return {
        label: item.metadata.name,
        value: item.metadata.name,
        extraOptions,
      };
    });
  return options;
}
